export const INFINITE_RADIUS = null;
export const NEAR_ME_RADIUS_KM = 25;
export const RADIUS_SLIDER_INFINITY = 201;

export const RADIUS_SLIDER_MARKS = [
  { value: 2, label: "2" },
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 100, label: "100" },
  { value: 200, label: "200" },
  { value: RADIUS_SLIDER_INFINITY, label: "∞" },
];

export function radiusFromSlider(value) {
  return value === RADIUS_SLIDER_INFINITY ? INFINITE_RADIUS : value;
}

export function radiusForSlider(value) {
  return value == null ? RADIUS_SLIDER_INFINITY : value;
}

export function radiusLabel(value) {
  return value == null ? "∞" : `${value} km`;
}
